<template>
  <el-row :gutter="10" type="flex" justify="space-between" class="json-editor-container">
    <el-col :span="16">
      <el-form label-position="top">
        <el-form-item v-if="isSelectKey">
          <el-select v-model="activeKey" @change="handleFieldChange">
            <el-option
              v-for="key in jsonKeys"
              :key="key"
              :label="key"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <template v-for="field in fields">
          <el-form-item :label="field.k" :key="field.k">
            <!-- 字符串类型 -->
            <el-input
              v-if="field.type === 'string'"
              v-model="field.v"
              @change="handleFieldChange"
            >
            </el-input>
            <!-- 数值类型 -->
            <el-input-number
              v-else-if="field.type === 'number'"
              v-model="field.v"
              controls-position="right"
              @change="handleFieldChange"
            >
            </el-input-number>
            <!-- 布尔类型 -->
            <el-checkbox
              v-else-if="field.type === 'boolean'"
              v-model="field.v"
              @change="handleFieldChange"
            >
              <el-tag :type="field.v ? 'primary' : 'info'">{{ field.v }}</el-tag>
            </el-checkbox>
          </el-form-item>
        </template>
      </el-form>
    </el-col>
    <el-col :span="8">
      <el-tag type="info">配置预览</el-tag>
      <vue-json-pretty
        :data="jsonData"
        :deep="0"
        :showDoubleQuotes="false"
        >
      </vue-json-pretty>
    </el-col>
  </el-row>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import objectGet from 'lodash/get';
import objectSet from 'lodash/set';
import { mytypeof, flattenObject } from '@/utils';

export default {
  model: {
    prop: 'jsonData',
    event: 'change',
  },
  props: {
    jsonData: {
      type: Object,
    },
    schema: {
      type: Object,
      defalut() {
        return {};
      },
    },
    isSelectKey: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueJsonPretty,
  },
  created() {
    this.setFields();
  },
  mounted() {
    // 设置默认值
    this.emitChange();
  },
  data() {
    let activeKey = '';
    if (this.isSelectKey) {
      const defaultActive = Object.keys(this.schema)[0];
      activeKey = this.jsonData.ACTIVE_KEY || defaultActive;
    }
    return {
      activeKey,
      fields: [],
    };
  },
  computed: {
    jsonKeys() {
      return Object.keys(this.schema);
    },
  },
  watch: {
    jsonData() {
      this.setFields();
    },
    activeKey() {
      this.setFields();
      this.emitChange();
    },
    schema() {
      this.setFields();
      this.emitChange();
    },
  },
  methods: {
    setFields() {
      this.fields = [];
      const flattened = flattenObject(this.schema)
        .filter(item => item.k.indexOf(this.activeKey) === 0);

      for (let i = 0; i < flattened.length; i += 1) {
        const { k, v: defaultV } = flattened[i];
        const v = objectGet(this.jsonData, k, defaultV);
        this.$set(this.fields, i, {
          k,
          v,
          type: mytypeof(v),
        });
      }
    },
    emitChange() {
      const json = this.isSelectKey ? { ACTIVE_KEY: this.activeKey } : {};
      for (let i = 0; i < this.fields.length; i += 1) {
        const { k, v } = this.fields[i];
        objectSet(json, k, v);
      }
      this.$emit('change', json);
    },

    handleFieldChange() {
      this.emitChange();
    },
  },
};
</script>

<style lang="scss" scoped>
.json-editor-container {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>

